import { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ContactButton } from '@/components/ContactButton';
import { APP_ROUTES, APP_ROUTES_CONFIG } from './utils/appRoutes';
import { ScrollToTop } from './components/ui/scroll-to-top';
import { SessionSync } from './components/auth/SessionSync';
import { Layout } from './components/layout';

export default function App() {
  return (
    <>
      <ScrollToTop />
      <SessionSync />
      <Suspense
        fallback={
          <div className="flex items-center justify-center min-h-screen">
            <div className="w-12 h-12 rounded-full border-4 border-primary/30 border-t-primary animate-[spin_0.8s_linear_infinite]"></div>
          </div>
        }
      >
        <Routes>
          <Route element={<Layout />}>
            {APP_ROUTES_CONFIG.map(({ path, Element }) => (
              <Route path={path} key={path} element={<Element />} />
            ))}
            <Route path={'*'} element={<Navigate to={APP_ROUTES.HOME} />} />
          </Route>
        </Routes>
      </Suspense>
      <ContactButton />
    </>
  );
}
